


export default {
    methods:{
        displayTitle(dataMain,dataPlus,display_title_for_nonadmin){
            // dataMain is string
            // dataPlus is Array
            if (this.userIsAdmin){
                return (dataMain.length > 0 || dataPlus.length>0 ) ? true : false
            }

            return display_title_for_nonadmin

        },
    }




}